<app-ui-bottom-sheet
  [open]="showDetalle && !!order"
  title="Detalle del despacho"
  closeAriaLabel="Cerrar detalle"
  (closed)="closeDetalle()"
>
  <ng-container *ngIf="order">
    <div class="order-summary">
      <div class="order-summary-text">
        <span class="order-summary-label">N° pedido</span>
        <span class="order-summary-value">{{ order.orderNumber }}</span>
      </div>
      <span class="status is-success" *ngIf="isDelivered(order)">
        <i class="bi bi-check-circle-fill"></i> Entregado
      </span>
      <span class="status is-pending" *ngIf="isPending(order)">
        <i class="bi bi-clock-fill"></i> Pendiente
      </span>
      <span class="status is-danger" *ngIf="isRejected(order)">
        <i class="bi bi-x-circle-fill"></i> Anulado
      </span>
    </div>

    <div class="detail-grid">
      <section class="detail-card">
        <div class="detail-row">
          <span class="detail-label">Producto</span>
          <span class="detail-value">{{ order.productDescription || "-" }}</span>
        </div>
        <div class="detail-row">
          <span class="detail-label">Guía</span>
          <span class="detail-value detail-guide">
            <app-pedidos-pendiente-visualizarguia
              [rutaPdf]="order.routePdfGuide"
              [tkt]="order.tkt.toString()"
              [numGuia]="order.folioNumberGD"
            ></app-pedidos-pendiente-visualizarguia>
          </span>
        </div>
        <div class="detail-row">
          <span class="detail-label">Estado de la guía</span>
          <span class="detail-value" *ngIf="isSigned(order)">
            <span class="guide-state is-signed"><i class="bi bi-check2"></i> Firmada</span>
          </span>
          <span class="detail-value" *ngIf="!isSigned(order)">
            <button type="button" class="guide-state-link" (click)="openAccion()">
              No firmada <i class="bi bi-chevron-right"></i>
            </button>
          </span>
        </div>
      </section>

      <section class="detail-card">
        <div class="detail-row">
          <span class="detail-label">Cantidad</span>
          <span class="detail-value">{{ order.actualQuantityShipped }} {{ order.um }}</span>
        </div>
        <div class="detail-row">
          <span class="detail-label">Motivo retorno</span>
          <span class="detail-value">{{ order.reasonToReturn || "-" }}</span>
        </div>
      </section>

      <section class="detail-card detail-card-full">
        <span class="detail-label">Observaciones</span>
        <p class="detail-remarks">{{ order.guidingRemarks || "Sin observaciones." }}</p>
      </section>
    </div>
  </ng-container>

  <button
    uiBottomSheetFooter
    type="button"
    class="btn btn-primary footer-close-btn"
    (click)="closeDetalle()"
  >
    Cerrar
  </button>
</app-ui-bottom-sheet>

<app-ui-bottom-sheet
  [open]="showAccion && !!order"
  closeAriaLabel="Cerrar acciones"
  maxWidth="600px"
  [mutedBody]="false"
  (closed)="closeAccion()"
>
  <div class="accion-body" *ngIf="order">
    <img src="assets/images/icons/warning_blue.svg" class="accion-icon" alt="" />
    <h2 class="accion-title">¿Qué deseas hacer con este despacho?</h2>
    <p class="accion-text">
      Tienes ambas opciones, firmarla generando un QR o enviarlo a despacho actual.
    </p>
    <div class="buttons">
      <button (click)="closeAccion()" type="button" class="btn btn-secondary">Volver</button>
      <button (click)="generateQr()" type="button" class="btn btn-secondary">Generar QR</button>
      <button (click)="moveToCurrentDispatch()" type="button" class="btn btn-primary">
        Enviar a "Despacho actual"
      </button>
    </div>
  </div>
</app-ui-bottom-sheet>
